import logger from '@src/utils/logger';
import { useCallback, useEffect, useState } from 'react';

const BYTES_TO_KB = 1024;

const useImageSize = (imageUrl: string, blob?: Blob | File) => {
  const [imageSizeKB, setImageSizeKB] = useState<number | null>(null);

  const fetchImageSize = useCallback(
    async (signal: AbortSignal) => {
      try {
        const response = await fetch(imageUrl, { method: 'HEAD', signal });
        const contentLength = response.headers.get('Content-Length');
        if (contentLength && !signal.aborted) {
          setImageSizeKB(Math.ceil(parseInt(contentLength, 10) / BYTES_TO_KB));
        }
      } catch (error) {
        if (!signal.aborted) {
          logger.error('画像サイズの取得に失敗しました:', error);
        }
      }
    },
    [imageUrl],
  );

  useEffect(() => {
    if (!imageUrl) {
      return;
    }

    if (blob && blob.size > 0) {
      setImageSizeKB(Math.ceil(blob.size / BYTES_TO_KB));
      return;
    }

    if (imageUrl.startsWith('blob:')) {
      setImageSizeKB(null);
      return;
    }

    const abortController = new AbortController();
    fetchImageSize(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [imageUrl, blob, fetchImageSize]);

  return imageSizeKB;
};

export default useImageSize;
